var AssetDirectory = {
	"load": [
		"assets/audio/bgm/wabbit_ingame_bgm.ogg",
		"assets/audio/sfx/button_01.ogg",
		"assets/audio/sfx/caught_something.ogg",
		"assets/audio/sfx/fishing_splash_loop.ogg",
		"assets/audio/sfx/fish_caught.ogg",
		"assets/audio/sfx/frog_spawn.ogg",
		"assets/audio/sfx/powerup_equip.ogg",
		"assets/audio/sfx/tap_dragonfly.ogg",
		"assets/audio/sfx/tap_frog.ogg",
		"assets/audio/sfx/tap_water.ogg",
		"assets/audio/sfx/throw_fishing_line.ogg",
		"assets/buttons/btn_achievement.png",
		"assets/buttons/btn_audio_0-2.png",
		"assets/buttons/btn_audio_1.png",
		"assets/buttons/btn_back.png",
		"assets/buttons/btn_checklist.png",
		"assets/buttons/btn_continue.png",
		"assets/buttons/btn_home.png",
		"assets/buttons/btn_no.png",
		"assets/buttons/btn_pause.png",
		"assets/buttons/btn_play.png",
		"assets/buttons/btn_start.png",
		"assets/buttons/btn_yes.png",
		"assets/checklist/achievement_bar.png",
		"assets/checklist/box_achievement.png",
		"assets/checklist/btn_down_scroll.png",
		"assets/checklist/btn_fishes_active.png",
		"assets/checklist/btn_fishes_idle.png",
		"assets/checklist/btn_junk_active.png",
		"assets/checklist/btn_junk_idle.png",
		"assets/checklist/btn_powerups_active.png",
		"assets/checklist/btn_powerups_idle.png",
		"assets/checklist/btn_up_scroll.png",
		"assets/checklist/check_achievement.png",
		"assets/checklist/con_achievement.png",
		"assets/checklist/con_achievement_dark.png",
		"assets/checklist/con_achievement_in_blank.png",
		"assets/checklist/inventory_bottom.png",
		"assets/checklist/inventory_frame1.png",
		"assets/checklist/inventory_frame2.png",
		"assets/checklist/inventory_header.png",
		"assets/checklist/inventory_middle.png",
		"assets/checklist/inventory_top.png",
		"assets/checklist/inventory_trophy.png",
		"assets/checklist/inventory_trophy2.png",
		"assets/checklist/nav_bar.png",
		"assets/checklist/nav_indicator.png",
		"assets/game/achievements/achieve_all.png",
		"assets/game/achievements/achieve_empty.png",
		"assets/game/achievements/achieve_first.png",
		"assets/game/achievements/achieve_fish_type.png",
		"assets/game/achievements/achieve_flies.png",
		"assets/game/achievements/achieve_master.png",
		"assets/game/achievements/achieve_power.png",
		"assets/game/achievements/achieve_ribbit.png",
		"assets/game/achievements/achieve_splash.png",
		"assets/game/achievements/achieve_weight.png",
		"assets/game/achievements/shdw/achieve_all_shdw.png",
		"assets/game/achievements/shdw/achieve_empty_shdw.png",
		"assets/game/achievements/shdw/achieve_first_shdw.png",
		"assets/game/achievements/shdw/achieve_fish_type_shdw.png",
		"assets/game/achievements/shdw/achieve_flies_shdw.png",
		"assets/game/achievements/shdw/achieve_master_shdw.png",
		"assets/game/achievements/shdw/achieve_power_shdw.png",
		"assets/game/achievements/shdw/achieve_ribbit_shdw.png",
		"assets/game/achievements/shdw/achieve_splash_shdw.png",
		"assets/game/achievements/shdw/achieve_weight_shdw.png",
		"assets/game/arrow_notif.png",
		"assets/game/bar.png",
		"assets/game/bar_bg.png",
		"assets/game/bar_fish.png",
		"assets/game/char_bugs_ske.json",
		"assets/game/char_bugs_tex.json",
		"assets/game/char_bugs_tex.png",
		"assets/game/coast_wave1.png",
		"assets/game/coast_wave2.png",
		"assets/game/con_trophy.png",
		"assets/game/dock_wave.png",
		"assets/game/fish/l_arowana.png",
		"assets/game/fish/l_oarfish.png",
		"assets/game/fish/l_pike.png",
		"assets/game/fish/l_sting.png",
		"assets/game/fish/l_swordfish.png",
		"assets/game/fish/m_catfish.png",
		"assets/game/fish/m_char.png",
		"assets/game/fish/m_largemouth.png",
		"assets/game/fish/m_milkfish.png",
		"assets/game/fish/m_salmon.png",
		"assets/game/fish/m_trout.png",
		"assets/game/fish/shdw_l_arowana.png",
		"assets/game/fish/shdw_l_oarfish.png",
		"assets/game/fish/shdw_l_pike.png",
		"assets/game/fish/shdw_l_sting.png",
		"assets/game/fish/shdw_l_swordfish.png",
		"assets/game/fish/shdw_m_catfish.png",
		"assets/game/fish/shdw_m_char.png",
		"assets/game/fish/shdw_m_largemouth.png",
		"assets/game/fish/shdw_m_milkfish.png",
		"assets/game/fish/shdw_m_salmon.png",
		"assets/game/fish/shdw_m_trout.png",
		"assets/game/fish/shdw_s_bicher.png",
		"assets/game/fish/shdw_s_clownfish.png",
		"assets/game/fish/shdw_s_crayfish.png",
		"assets/game/fish/shdw_s_goldfish.png",
		"assets/game/fish/shdw_s_jelly1.png",
		"assets/game/fish/shdw_s_minnow.png",
		"assets/game/fish/shdw_s_piranha.png",
		"assets/game/fish/shdw_s_starfish.png",
		"assets/game/fish/s_bicher.png",
		"assets/game/fish/s_clownfish.png",
		"assets/game/fish/s_crayfish.png",
		"assets/game/fish/s_goldfish.png",
		"assets/game/fish/s_jelly1.png",
		"assets/game/fish/s_minnow.png",
		"assets/game/fish/s_piranha.png",
		"assets/game/fish/s_starfish.png",
		"assets/game/go_green.png",
		"assets/game/junk/junk_bag.png",
		"assets/game/junk/junk_cup.png",
		"assets/game/junk/junk_plastic.png",
		"assets/game/junk/junk_styro.png",
		"assets/game/junk/shdw_junk_bag.png",
		"assets/game/junk/shdw_junk_cup.png",
		"assets/game/junk/shdw_junk_plastic.png",
		"assets/game/junk/shdw_junk_styro.png",
		"assets/game/notif.png",
		"assets/game/notif_hard.png",
		"assets/game/objects_ske.json",
		"assets/game/objects_tex.json",
		"assets/game/objects_tex.png",
		"assets/game/powerup/dark_hat_icon1.png",
		"assets/game/powerup/dark_hat_icon2.png",
		"assets/game/powerup/dark_hook_icon1.png",
		"assets/game/powerup/dark_hook_icon2.png",
		"assets/game/powerup/hat_icon1.png",
		"assets/game/powerup/hat_icon2.png",
		"assets/game/powerup/hook_icon1.png",
		"assets/game/powerup/hook_icon2.png",
		"assets/game/powerup/pup_hat1.png",
		"assets/game/powerup/pup_hat2.png",
		"assets/game/powerup/pup_hook1.png",
		"assets/game/powerup/pup_hook2.png",
		"assets/game/trophy_gold.png",
		"assets/game/trophy_shdw.png",
		"assets/game/trophy_sign.png",
		"assets/game/WB_con_note.png",
		"assets/game/WB_ingame_starburst.png",
		"assets/pause/btn_htp_next.png",
		"assets/pause/htp_desktop_0.png",
		"assets/pause/htp_desktop_1.png",
		"assets/pause/htp_desktop_2.png",
		"assets/pause/htp_mobile_0.png",
		"assets/pause/htp_mobile_1.png",
		"assets/pause/htp_mobile_2.png",
		"assets/pause/htp_pg_0.png",
		"assets/pause/htp_pg_1.png",
		"assets/pause/WB_con_header.png",
		"assets/pause/WB_con_pause.png",
		"assets/post/end_bg.png",
		"assets/post/end_radial.png",
		"assets/post/game-summary.png",
		"assets/post/WB_congrats_word.png",
		"assets/title/back_bg.png",
		"assets/title/WB_title_bg_foreground.png",
		"assets/title/WB_title_character.png",
		"assets/title/WB_title_logo_ar.png",
		"assets/title/WB_title_logo_da.png",
		"assets/title/WB_title_logo_de.png",
		"assets/title/WB_title_logo_en.png",
		"assets/title/WB_title_logo_es.png",
		"assets/title/WB_title_logo_fr.png",
		"assets/title/WB_title_logo_hu.png",
		"assets/title/WB_title_logo_it.png",
		"assets/title/WB_title_logo_nl.png",
		"assets/title/WB_title_logo_no.png",
		"assets/title/WB_title_logo_pl.png",
		"assets/title/WB_title_logo_pt.png",
		"assets/title/WB_title_logo_ro.png",
		"assets/title/WB_title_logo_ru.png",
		"assets/title/WB_title_logo_sv.png",
		"assets/title/WB_title_logo_tr.png"
	],
	"preload": [
		"assets/preload/animation/loader_animation0001.png",
		"assets/preload/animation/loader_animation0002.png",
		"assets/preload/animation/loader_animation0003.png",
		"assets/preload/animation/loader_animation0004.png",
		"assets/preload/animation/loader_animation0005.png",
		"assets/preload/animation/loader_animation0006.png",
		"assets/preload/animation/loader_animation0007.png",
		"assets/preload/animation/loader_animation0008.png",
		"assets/preload/animation/loader_animation0009.png",
		"assets/preload/animation/loader_animation0010.png",
		"assets/preload/bar_bg.png",
		"assets/preload/bar_fill.png",
		"assets/preload/fonts/dimboregular.otf",
		"assets/preload/fonts/lakkireddy.otf",
		"assets/preload/fonts/nuevastd-bold.otf",
		"assets/preload/frame.png",
		"assets/preload/icon_rotate.png"
	],
	"preloadstring": [
		"assets/strings/achievement_data.json",
		"assets/strings/localization/config.xml",
		"assets/strings/localization/locale_ar.xml",
		"assets/strings/localization/locale_da.xml",
		"assets/strings/localization/locale_de.xml",
		"assets/strings/localization/locale_en.xml",
		"assets/strings/localization/locale_es.xml",
		"assets/strings/localization/locale_fr.xml",
		"assets/strings/localization/locale_hu.xml",
		"assets/strings/localization/locale_it.xml",
		"assets/strings/localization/locale_nl.xml",
		"assets/strings/localization/locale_no.xml",
		"assets/strings/localization/locale_pl.xml",
		"assets/strings/localization/locale_pt.xml",
		"assets/strings/localization/locale_ro.xml",
		"assets/strings/localization/locale_ru.xml",
		"assets/strings/localization/locale_sv.xml",
		"assets/strings/localization/locale_tr.xml",
		"assets/strings/rarity_0.json",
		"assets/strings/rarity_1.json",
		"assets/strings/rarity_2.json"
	]
};